import React, { useEffect, useState, useRef } from 'react';
import { Form, Container, Alert } from 'react-bootstrap';
import api from '../../../services/client';
import { setValue } from '../../../helpers/localStorageHelper';
import styled from 'styled-components';
import routes from '../../routes';
import { useHistory } from 'react-router-dom';
import BannerImage from '../../../assets/JobBoard_Banner.png';
import TitleImage from '../../../assets/resetpass.png';


const Banner = styled.div`
    background-image: url(${BannerImage});
    min-height: 400px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    @media screen and (max-width: 450px) {
        min-height: 225px;
    }
`;
const Title = styled.div`
    background-image: url(${TitleImage});
    min-height: 95px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 65%;    
    margin: 25px auto;
    @media screen and (max-width: 450px) {
        min-height: 60px;
    }
`;

const LoginHeader = styled.div`
    padding: 4% 6%;
`;

const MessageContent = styled.div`
    height: 200px;  
    display: flex;
    justify-content: center;
    align-items: end;
    font-size: 3rem;
    color: #0A3BB4;

    @media screen and (max-width: 768px) {
        font-size: 2rem;
    }
`;


function ForgotPassword() {
    const history = useHistory();
    const [error, setError] = useState(false);
    const [message, setMessage] = useState();
    const [showReset, setShowReset] = useState(true);
    const [userEmail, setUserEmail] = useState('');
    const fotgotPasswordForm = useRef();

    function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    const handleOnSubmit = async (e) => {
        e.preventDefault();
        setError(false);
        var formData = new FormData(fotgotPasswordForm.current),
            formDataObj = Object.fromEntries(formData.entries());
        if (validateEmail(formDataObj.Email)) {
            await api.checkValidUser(formDataObj).then((result) => {
                 setShowReset(false);
                 setError(true);
                 setMessage("Password Reset Link has been sent to your email!")
              }).catch((res) => {
                setError(true);
                setMessage(res?.response?.data?.message ?? "Internal server error");
              })
        } else {
            setError(true);
            setMessage('invalid emaid id');
        }
    }


    return showReset ? (
        <>
            <Banner />
            <Title />
            <div className='signup-container'>
                <Container>
                    <Form ref={fotgotPasswordForm}>
                        <LoginHeader>
                            <p className="text-center"> {showReset ? 'Enter Password To Reset' : 'Enter Your Emai Id To Reset Password' } </p>
                            <Form.Group className="mb-2" controlId="formBasicUsernameEmail">
                                <Form.Control type="email" name="Email" placeholder="Email Address" style={{border: `1px solid ${error ? 'red' : '#ced4da'}`}}/>
                                {error && <p className='text-danger' style={{marginBottom:0, marginTop:'5px'}}> {message} </p>}
                            </Form.Group>
                        </LoginHeader>

                    </Form>
                    <button className='btnClass' onClick={handleOnSubmit}>Submit</button>
                </Container>
            </div>
        </>
    ): (
        <>
            <MessageContent className='text-center'>
                {message}               
            </MessageContent>
            {error && <div className='text-center'>Please check you mail</div>}
            
        </>
    )
}

export default ForgotPassword

